/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3 4.5c.8284 0 1.5-.6716 1.5-1.5S3.8284 1.5 3 1.5 1.5 2.1716 1.5 3 2.1716 4.5 3 4.5ZM3 6a2.9862 2.9862 0 0 0 1.524-.4154L6.8903 7.951a2 2 0 0 0-.9525 1.7037v4.6906a2 2 0 0 0 .9525 1.7037l-.7712.7712-1.5952 1.5952A2.9852 2.9852 0 0 0 3 18c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3c1.6569 0 3-1.3431 3-3a2.9859 2.9859 0 0 0-.4154-1.524l1.5951-1.5951 1.0549-1.0549L11 18.4226a1.9998 1.9998 0 0 0 2 0l2.7654-1.5965 2.65 2.6499A2.9855 2.9855 0 0 0 18 21c0 1.6569 1.3431 3 3 3s3-1.3431 3-3-1.3431-3-3-3a2.9855 2.9855 0 0 0-1.524.4154l-2.3663-2.3664a2 2 0 0 0 .9525-1.7037V9.6547c0-.696-.3618-1.3406-.9525-1.7038l2.3663-2.3663C19.9226 5.8486 20.4436 6 21 6c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 .5564.1514 1.0773.4154 1.524l-2.65 2.65L13 5.5772a2 2 0 0 0-2 0L8.2346 7.174l-2.65-2.65A2.9862 2.9862 0 0 0 6 3c0-1.6568-1.3431-3-3-3-1.6568 0-3 1.3432-3 3 0 1.6569 1.3432 3 3 3Zm1.5 15c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5ZM21 4.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5ZM22.5 21c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Z"
    clipRule="evenodd"
  />,
  'MenuConnectionsFilled'
);
